module.exports = __webpack_public_path__ + "img/icon-people.98dcce34.png";